import {combineReducers} from 'redux';

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'QUESTIONBANK_CATEGORIES_LOADED':
      return action.categories;
    default:
      return state;
  }
}
export function retrieveError(state = null, action) {
  switch (action.type) {
    case 'QUESTIONBANK_CATEGORIES_LOAD_ERROR':
      return action.error;
    default:
      return state;
  }
}
export default combineReducers({retrieved, retrieveError});
